import { EmblaCarouselType } from 'embla-carousel'

export const addThumbBtnsClickHandlers = (
  emblaApiMain: EmblaCarouselType,
  emblaApiThumb: EmblaCarouselType
): () => void => {
  const slidesThumbs = emblaApiThumb.slideNodes()

  const mainSliderScroll = ( index: number ) => {
    console.log( 'mainSliderScroll', index )
    emblaApiMain.scrollTo( index )
  }

  slidesThumbs.forEach( ( slideNode, index ) => {
    slideNode.addEventListener( 'click', () => {
      mainSliderScroll( index )
    }, false )
  } )

  return () => {
    slidesThumbs.forEach( ( slideNode, index ) => {
      slideNode.removeEventListener( 'click', () => mainSliderScroll( index ), false )
    } )
  }
}

export const addToggleThumbBtnsActive = (
  emblaApiMain: EmblaCarouselType,
  emblaApiThumb: EmblaCarouselType
): () => void => {
  const slidesThumbs = emblaApiThumb.slideNodes()

  const toggleThumbBtnsState = () => {
    emblaApiThumb.scrollTo( emblaApiMain.selectedScrollSnap() )
    const previous = emblaApiMain.previousScrollSnap()
    const selected = emblaApiMain.selectedScrollSnap()
    slidesThumbs[previous].classList.remove( 'embla-thumbs__slide--selected' )
    slidesThumbs[selected].classList.add( 'embla-thumbs__slide--selected' )
  }

  emblaApiMain.on( 'select', toggleThumbBtnsState )
  emblaApiThumb.on( 'init', toggleThumbBtnsState )

  return () => {
    const selected = emblaApiMain.selectedScrollSnap()
    slidesThumbs[selected].classList.remove( 'embla-thumbs__slide--selected' )
  }
}
